import { Storage } from './../Core/Storage';

export class Ajax {

	static post(url, postData, onSuccess,  onError) {
		var ajaxData = this.getAjaxData(url, postData);
		$.ajax(ajaxData)
			.done(function (data) {
				if (onSuccess) onSuccess(data);
			})
			.fail(function(xhr, status, error) {
				console.log(xhr);
				if (onError)
					onError(xhr, status, error);
				//Functions.proccessFailedRequest(xhr, onError, onValidationError, error);
			});
	}

	static postPlain(url, postData) {
		return $.ajax(this.getAjaxData(url, postData));
	}

	static get(url, data, onSuccess, onError) {
		var errorCallback = onError == null ? function (response) { } : onError;
		var successCallback = onSuccess == null ? function (response) { } : onSuccess;		
		try {
			$.getJSON({
				url: url,
				beforeSend: (xhr) => {
					if (Storage.instance().token) {
						xhr.setRequestHeader("Authorization", "Bearer " + Storage.instance().token);
					}
				},
				data: data
			})
				.done(function (response) {
					successCallback(response);
				})
				.fail(function (xhr, status, error) {
					console.log(xhr);
					if (onError)
						onError(xhr, status, error);
			//		Functions.proccessFailedRequest(xhr, errorCallback, errorValidCallback, error);//todo
				})

		}
		catch (error) {
			errorCallback(error.Message);
		}
	}

	static getPlain(url, data) {
		return $.get({
			url: url,
			beforeSend: (xhr) => {
				if (Storage.instance().token)
					xhr.setRequestHeader("Authorization", "Bearer " + Storage.instance().token);
			},
			data: data
		});
	}

	static GetError(xhr) {
		var err = { msg: xhr.statusText, sysMsg: xhr.statusText };
		if (xhr.responseJSON) {
			if (xhr.responseJSON.isValidationError) {
				var modelState = xhr.responseJSON.modelState;
				if (modelState) {

					for (var propertyName in modelState) {
						if (modelState.hasOwnProperty(propertyName) && modelState[propertyName].errors && modelState[propertyName].errors.length > 0) {
							err.msg = modelState[propertyName].errors[0].errorMessage;
						}
			/*			else if (propertyName == "user" && modelState[propertyName].length>0) {
							err.msg = modelState[propertyName][0];
						}*/
					}
					err.modelState = modelState;
				}
			}
			else if (xhr.responseJSON.message) {
				err.msg = xhr.responseJSON.message;
			}
		}
		return err;
	}

	static getAjaxData = function(url, postData) {
		return {
			'type': 'POST',
			'url': url,
			'contentType': 'application/json',
			'data': JSON.stringify(postData), //allows sending empty arrays
			'beforeSend': function(xhr) {
				var token = Storage.instance().token;
				if (token)
					xhr.setRequestHeader('Authorization', 'Bearer ' + token);
			}
		};
	}
}
